<template>
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.7222 12.5334L8.92716 12.5334L4.89745 8.00011L8.92716 3.46678L10.7222 3.46678L10.7222 4.53345L9.40616 4.53345L6.32462 8.00011L9.40616 11.4668L10.7222 11.4668L10.7222 12.5334Z"
            fill="white"
        />
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
